import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.REACT_APP_BACKEND_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const nomesService = {
  buscarNomes: async (status = 'ATIVO', nome = '', skip = 0, limit = 100) => {
    const params = { status, skip, limit };
    if (nome) {
      params.nome = nome;
    }
    const response = await api.get('/client/nomes/', { params });
    return response.data;
  },

  buscarTotalNomes: async (status = 'ATIVO', nome = '') => {
    const params = { status };
    if (nome) {
      params.nome = nome;
    }
    const response = await api.get('/client/nomes/count', { params });
    // O endpoint retorna diretamente um número, então transformamos em um objeto
    // com a propriedade count para manter a consistência
    const count = response.data;
    return { count };
  },

  cancelarNome: async (id) => {
    const response = await api.delete(`/client/nomes/${id}`);
    return response.data;
  },

  buscarStatusNomes: async () => {
    const response = await api.get('/client/enums/nome-status');
    return response.data;
  },
  
  adicionarNome: async (novoNome) => {
    const response = await api.post('/client/nomes/', novoNome);
    return response.data;
  },
};  



export const enumsService = {
  buscarPolo: async () => {
    const response = await api.get('/client/enums/polo');
    return response.data;
  },
  buscarDistribuicaoStatus: async () => {
    const response = await api.get('/client/enums/distribuicao-status');
    return response.data;
  },
  buscarNomeStatus: async () => {
    const response = await api.get('/client/enums/nome-status');
    return response.data;
  },
  buscarTipoConsulta: async () => {
    const response = await api.get('/client/enums/tipo-consulta');
    return response.data;
  },

};

export const arrendatarioService = {
  buscarArrendatario: async () => {
    const response = await api.get('/client/arrendatario');
    return response.data;
  },

  criarArrendatario: async () => {
    const response = await api.post('/client/arrendatario');
    return response.data;
  },

  atualizarArrendatario: async (dados) => {
    const response = await api.put('/client/arrendatario', dados);
    return response.data;
  },
};

export const distribuicaoService = {
  buscarDistribuicaoAbrangencia: async () => {
    const response = await api.get('/client/distribuicao-abrangencias');
    return response.data;
  },
  buscarDistribuicao: async (status = null, dataInicio = null, dataFim = null, numeroProcesso = null, skip = 0, limit = 100) => {
    // Construir os parâmetros da consulta
    let params = { skip, limit, order: 'desc' };
    
    if (status && status !== 'Todos') {
      // Garantir que o status seja passado no formato correto (Finalizado ao invés de FINALIZADO)
      params.status = status;
    }
    
    if (dataInicio) {
      params.data_inicio = dataInicio;
    }
    
    if (dataFim) {
      params.data_fim = dataFim;
    }
    
    if (numeroProcesso) {
      params.numero_processo = numeroProcesso;
    }
    
    // Construir a URL com os parâmetros
    const response = await api.get('/client/distribuicoes/', { params });
    return response.data;
  },
  buscarDistribuicaoStatus: async () => {
    const response = await api.get('/client/enums/distribuicao-status');
    return response.data;
  },

};

export default api;
